import { useEffect } from "react"
import nProgress from "nprogress"

import { userInitiatedSignOut } from "@/lib/auth/client"
import { MtSSP } from "@/lib/mt-server-side-props"
import { webStorage } from "@/lib/web-storage"

export default function AuthEnableV2Page() {
  useEffect(() => {
    nProgress.start()
    webStorage.setItem("mindtrip.auth_v2", "1")
    // use this one as it will take to home, and clear all cookies/local storage
    void userInitiatedSignOut()
  }, [])
  return null
}

export const getServerSideProps = MtSSP.publicPage()
